import { useRef, useState, useCallback, useEffect } from 'react';
import scrollIntoView from 'scroll-into-view';

export const DEVICE_SIZES_VALUE = {
  MOBILE: 767,
  // MOBILE: 576,
  TABLET: 768,
  DESKTOP: 992,
  LARGE_DESKTOP: 1200,
};

export const DEVICE_TYPE = {
  MOBILE_ONLY: 'mobileOnly',
  TABLET_ONLY: 'tabletOnly',
  UP_TO_TABLET: 'upToTablet',
  DESKTOP_ONLY: 'desktopOnly',
};

const mobileOnly = (useParent = false) =>
  (useParent ? window.parent.innerWidth : window.innerWidth) < DEVICE_SIZES_VALUE.MOBILE;
const tabletOnly = (useParent = false) =>
  (useParent ? window.parent.innerWidth : window.innerWidth) > DEVICE_SIZES_VALUE.MOBILE &&
  (useParent ? window.parent.innerWidth : window.innerWidth) < DEVICE_SIZES_VALUE.DESKTOP;

const upToTablet = (useParent = false) =>
  (useParent ? window.parent.innerWidth : window.innerWidth) < DEVICE_SIZES_VALUE.DESKTOP;

const desktopOnly = (useParent = false) =>
  (useParent ? window.parent.innerWidth : window.innerWidth) > DEVICE_SIZES_VALUE.DESKTOP;

const findViewType = (deviceType, useParent = false) => {
  switch (deviceType) {
    case DEVICE_TYPE.MOBILE_ONLY:
      return mobileOnly(useParent);

    case DEVICE_TYPE.TABLET_ONLY:
      return tabletOnly(useParent);

    case DEVICE_TYPE.UP_TO_TABLET:
      return upToTablet(useParent);

    case DEVICE_TYPE.DESKTOP_ONLY:
      return desktopOnly(useParent);

    default:
      return false;
  }
};

export const useView = (type, useParent = false) => {
  const isInit = useRef(true);
  const [isTypeFound, setIsTypeFound] = useState(false);

  const handleResize = useCallback(() => {
    setIsTypeFound(findViewType(type, useParent));
  }, [type, useParent]);

  useEffect(() => {
    // To avoid window undefined error in SSR
    if (process.browser) {
      if (useParent) {
        window.parent.addEventListener('resize', handleResize);
      } else {
        window.addEventListener('resize', handleResize);
      }
      return () => {
        if (useParent) {
          window.parent.removeEventListener('resize', handleResize);
        } else {
          window.removeEventListener('resize', handleResize);
        }
      };
    }
  }, [handleResize]);

  useEffect(() => {
    // will Skip this after first render
    if (isInit && isInit.current) {
      setIsTypeFound(findViewType(type, useParent));
      isInit.current = false;
    }
  }, [isInit, type, useParent]);

  return isTypeFound;
};

export const scrollTohash = (hash = '', e) => {
  const elements = document.querySelectorAll(hash);
  if (e) {
    e.preventDefault();
  }

  if (elements.length) {
    scrollIntoView(elements[0], { align: { top: 0, topOffset: 75 } });
    setTimeout(() => {
      window.location = hash;
    }, 1000);
  }
};
